import React from 'react';

interface IconAlertTriangleProps {
    iconClasses?: string;
}

const IconAlertTriangle: React.FC<IconAlertTriangleProps> = ({ iconClasses }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-alert-triangle ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M28.1999 20.375L18.6124 4.47498C18.2247 3.8685 17.6906 3.36939 17.0592 3.02366C16.4279 2.67792 15.7197 2.4967 14.9999 2.4967C14.2801 2.4967 13.5719 2.67792 12.9405 3.02366C12.3092 3.36939 11.7751 3.8685 11.3874 4.47498L1.79988 20.375C1.4612 20.9396 1.27712 21.5833 1.26615 22.2416C1.25517 22.8999 1.4177 23.5494 1.73738 24.125C2.10698 24.7728 2.64196 25.3109 3.28763 25.6843C3.93331 26.0576 4.66654 26.2528 5.41238 26.25H24.5874C25.3283 26.2579 26.0582 26.0702 26.7035 25.7059C27.3487 25.3416 27.8864 24.8135 28.2624 24.175C28.5915 23.5935 28.7592 22.9346 28.7482 22.2665C28.7372 21.5984 28.5479 20.9454 28.1999 20.375ZM26.0749 22.9375C25.9247 23.1957 25.7066 23.4079 25.4444 23.5512C25.1822 23.6944 24.8859 23.7631 24.5874 23.75H5.41238C5.11391 23.7631 4.81753 23.6944 4.55533 23.5512C4.29313 23.4079 4.07511 23.1957 3.92488 22.9375C3.81517 22.7475 3.75741 22.5319 3.75741 22.3125C3.75741 22.0931 3.81517 21.8775 3.92488 21.6875L13.5249 5.77498C13.6974 5.54712 13.9203 5.36231 14.1763 5.23507C14.4322 5.10784 14.7141 5.04162 14.9999 5.04162C15.2857 5.04162 15.5676 5.10784 15.8235 5.23507C16.0794 5.36231 16.3024 5.54712 16.4749 5.77498L26.0624 21.675C26.1763 21.8654 26.2375 22.0827 26.2397 22.3045C26.2419 22.5264 26.185 22.7449 26.0749 22.9375Z"
                fill="currentColor"
            />
            <path
                d="M15 21.25C15.6904 21.25 16.25 20.6904 16.25 20C16.25 19.3096 15.6904 18.75 15 18.75C14.3096 18.75 13.75 19.3096 13.75 20C13.75 20.6904 14.3096 21.25 15 21.25Z"
                fill="currentColor"
            />
            <path
                d="M15 10C14.6685 10 14.3505 10.1317 14.1161 10.3661C13.8817 10.6005 13.75 10.9185 13.75 11.25V16.25C13.75 16.5815 13.8817 16.8995 14.1161 17.1339C14.3505 17.3683 14.6685 17.5 15 17.5C15.3315 17.5 15.6495 17.3683 15.8839 17.1339C16.1183 16.8995 16.25 16.5815 16.25 16.25V11.25C16.25 10.9185 16.1183 10.6005 15.8839 10.3661C15.6495 10.1317 15.3315 10 15 10Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconAlertTriangle;
